function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinejoin: "round",
  d: "M29.5 13v15a3 3 0 01-3 3h-21a3 3 0 01-3-3V13"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M29.5 7v6h-27V7a3 3 0 013-3h21a3 3 0 013 3zM22 0v8M10 0v8"
}));

function SvgEvents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 33"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMyI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIpIj4KICAgIDxwYXRoIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTI3LjUsMTMgTDI3LjUsMjggQzI3LjUsMjkuNjU2ODU0MiAyNi4xNTY4NTQyLDMxIDI0LjUsMzEgTDMuNSwzMSBDMS44NDMxNDU3NSwzMSAwLjUsMjkuNjU2ODU0MiAwLjUsMjggTDAuNSwxMyIvPgogICAgPHBhdGggc3Ryb2tlPSIjMjNDMzg2IiBkPSJNMjcuNSw3IEwyNy41LDEzIEwwLjUsMTMgTDAuNSw3IEMwLjUsNS4zNDMxNDU3NSAxLjg0MzE0NTc1LDQgMy41LDQgTDI0LjUsNCBDMjYuMTU2ODU0Miw0IDI3LjUsNS4zNDMxNDU3NSAyNy41LDcgWiIvPgogICAgPGxpbmUgeDE9IjIwIiB4Mj0iMjAiIHkyPSI4IiBzdHJva2U9IiMyM0MzODYiLz4KICAgIDxsaW5lIHgxPSI4IiB4Mj0iOCIgeTI9IjgiIHN0cm9rZT0iIzIzQzM4NiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgEvents as ReactComponent };